import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/stores/authContext';
import { tokenStore } from '@/auth/tokenStore';
import { decodeAccessToken } from '@/auth/tokenClaims';
import ForcePasswordChange from '@/components/auth/ForcePasswordChange';
import { ROUTES } from '@/routes/paths';

// Guards protected routes. Пока идёт восстановление сессии (refresh при загрузке) — показываем
// лоадер, НЕ редиректим (иначе прямой заход на /app/* сбрасывал бы на логин). Аноним → на login
// с сохранением целевого URL (без бизнес-контекста — domain-spec.md, упрощение 3). Вход по временному
// паролю (password_change_required) → форс-смена пароля до доступа к приложению.
export default function RequireAuth() {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return (
      <Center h="100dvh">
        <Loader />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ returnTo: location.pathname }} />;
  }

  if (decodeAccessToken(tokenStore.getAccess())?.passwordChangeRequired) {
    return <ForcePasswordChange />;
  }

  return <Outlet />;
}
